export const isNode = () =>
  'undefined' !== typeof process &&
  process.release &&
  'node' === process.release.name;

export const isProductionHostname = () =>
  /^.*babbel\.com|babbel-magazine-production.herokuapp.com$/
    .test(window.location.hostname);

export const isProductionMode = () =>
  'production' === process.env.NODE_ENV;

export const isRetinaDisplay = () =>
  2 <= window.devicePixelRatio;

export const isStagingHostname = () =>
  /^.*babbel\.cn|babbel-magazine-staging.herokuapp.com$/
    .test(window.location.hostname);

export const isWindows = () =>
  'Win32' === window.navigator.platform;

export const isIosDevice = () =>
  /i(Pad|Phone)/.test(window.navigator.platform);

export default isNode;
